//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageHeader from "@/0/components/comForm/comPageHeader";
import FormEdit from "@/0/components/comForm/comFormEdit2";
import FormOperateList from "@/0/components/comForm/comOperateList/comFormOperateList2.vue";

export default {
  components: {
    "page-header": PageHeader,
    "form-edit": FormEdit,
    "form-operate-list": FormOperateList,
  },
  props: ["dataConfig"],
  data() {
    return {
      $manager: null,

      headerConfig: {
        Title: "创建表单"
      },
      operateListConfig: {
        isHideBack: true,
        ButtonList: []
      },
      isFormInit: false,
      formConfig: {},
      formViewDataList: [],
      fromNavStepView: {}
    };
  },

  async created() {
    this.$manager = this.$parent.getManager();
    if (!this.$manager) {
      this.$msg.alert("当前的$Manager对象不能为空.");
      return;
    }
    await this.initForm();
  },

  methods: {

    $getSubmitData(){
      var formData = this.$refs.comFormEdit.$getSubmitData();
      return formData;      
    },

    async initForm() {
      this.isFormInit = false;
      this.$msg.showLoading("正在核验...");
      var result = await this.$manager.getCreateForm();
      this.$msg.hideLoading();
      if (result.state == 1) {
        this.isFormInit = true;
        this.$msg.succ("核验通过");

        var resultData = result.data;

        this.headerConfig.Title = resultData.Title;
        this.formViewDataList = resultData.GroupViewList;
        this.fromNavStepView = resultData.NavStepView;
        console.log("this.fromNavStepView", resultData.NavStepView);
        
        setTimeout(() => {
          console.log("this.$refs.comFormOperateList",this.$refs.comFormOperateList);
          this.$refs.comFormOperateList.setData(resultData.OperateList);
        },0);
        return;
      }
      this.$msg.alert(result.msg);
    },

    $getActionObj(){
      var actionObj = this.$refs.comFormOperateList.$getActionObj();
      console.log("actionObj",actionObj);
      return actionObj;
    },


    getComFormEdit(){
      return this.$refs.comFormEdit;
    },

    async _onSubmitClick() {
      var postData = this.$refs.comFormEdit.getSubmitData();
      console.log(postData);
      this.$msg.showLoading("正在提交...");
      var result = await this.$manager.submitCreate(postData);
      this.$msg.hideLoading();

      if (result.state == 1) {
        this.$msg.succ(result.msg);
        var dataItem = result.data;
        this.$parent.onSubmitSucc(dataItem, result);
        return;
      }
      this.$msg.alert(result.msg);
      // console.log(result);
    },
    
    refreshForm() {
      this.initForm();
    }
  }
};
